var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-main"},[_c('div',{staticClass:"app-main__wrapper"},[_c('div',{staticClass:"app-main__content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }